import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import classnames from "classnames";
import { Box } from "../../../../../../Box/index.js";
import { Typography } from "../../../../../../Typography/index.js";
import { DropdownButton } from "../../../../../../DropdownButton/index.js";
import { MenuItem } from "../../../../../../MenuItem/index.js";
import { QuoteDialog } from "../index.js";
import { useStyles } from "./Quote.styles.js";
const Quote = (t0)=>{
    const $ = c(41);
    const { text, author: t1, editor, setData, remove } = t0;
    const author = void 0 === t1 ? "" : t1;
    const { classes } = useStyles();
    const [quoteText, setQuoteText] = useState(text);
    const [quoteAuthor, setQuoteAuthor] = useState(author);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isQuoteDialogOpen, setIsQuoteDialogOpen] = useState(false);
    let t2;
    if ($[0] !== editor) {
        t2 = editor.isEditable();
        $[0] = editor;
        $[1] = t2;
    } else t2 = $[1];
    const isEditable = t2;
    let t3;
    if ($[2] !== classes.activeMenu || $[3] !== classes.menu || $[4] !== isMenuOpen || $[5] !== isQuoteDialogOpen) {
        t3 = isMenuOpen || isQuoteDialogOpen ? classnames([
            classes.menu,
            classes.activeMenu
        ]) : classes.menu;
        $[2] = classes.activeMenu;
        $[3] = classes.menu;
        $[4] = isMenuOpen;
        $[5] = isQuoteDialogOpen;
        $[6] = t3;
    } else t3 = $[6];
    const classesByCondition = t3;
    let t4;
    let t5;
    if ($[7] !== author || $[8] !== text) {
        t4 = ()=>{
            setQuoteAuthor(author);
            setQuoteText(text);
        };
        t5 = [
            text,
            author
        ];
        $[7] = author;
        $[8] = text;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    useEffect(t4, t5);
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsQuoteDialogOpen(true);
        };
        $[11] = t6;
    } else t6 = $[11];
    const handleQuoteDialogOpen = t6;
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsQuoteDialogOpen(false);
        };
        $[12] = t7;
    } else t7 = $[12];
    const handleQuoteDialogClose = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setIsMenuOpen(true);
        };
        $[13] = t8;
    } else t8 = $[13];
    const handleMenuOpen = t8;
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            setIsMenuOpen(false);
        };
        $[14] = t9;
    } else t9 = $[14];
    const handleMenuClose = t9;
    let t10;
    if ($[15] !== editor || $[16] !== setData) {
        t10 = (authorData, textData)=>{
            editor.update(()=>{
                setData(textData, authorData);
            });
        };
        $[15] = editor;
        $[16] = setData;
        $[17] = t10;
    } else t10 = $[17];
    const handleSubmit = t10;
    let t11;
    if ($[18] !== classes.author || $[19] !== quoteText) {
        t11 = /*#__PURE__*/ jsx(Typography, {
            className: classes.author,
            variant: "body2",
            children: quoteText
        });
        $[18] = classes.author;
        $[19] = quoteText;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== quoteAuthor) {
        t12 = quoteAuthor && /*#__PURE__*/ jsx(Typography, {
            variant: "subtitle1",
            children: quoteAuthor
        });
        $[21] = quoteAuthor;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== classesByCondition || $[24] !== isEditable || $[25] !== remove) {
        t13 = isEditable && /*#__PURE__*/ jsx(Box, {
            className: classesByCondition,
            children: /*#__PURE__*/ jsx(Box, {
                position: "absolute",
                top: "12px",
                right: "8px",
                children: /*#__PURE__*/ jsx(DropdownButton, {
                    onOpen: handleMenuOpen,
                    onClose: handleMenuClose,
                    size: "small",
                    variant: "quaternary",
                    verticalPosition: "bottom",
                    horizontalPosition: "right",
                    menuItems: /*#__PURE__*/ jsxs(Box, {
                        display: "flex",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ jsx(MenuItem, {
                                onClick: handleQuoteDialogOpen,
                                children: /*#__PURE__*/ jsx(Typography, {
                                    variant: "body2",
                                    children: "Редактировать"
                                })
                            }),
                            /*#__PURE__*/ jsx(MenuItem, {
                                onClick: remove,
                                children: /*#__PURE__*/ jsx(Typography, {
                                    variant: "body2",
                                    children: "Удалить"
                                })
                            })
                        ]
                    })
                })
            })
        });
        $[23] = classesByCondition;
        $[24] = isEditable;
        $[25] = remove;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== classes.quote || $[28] !== t11 || $[29] !== t12 || $[30] !== t13) {
        t14 = /*#__PURE__*/ jsxs(Box, {
            className: classes.quote,
            children: [
                t11,
                t12,
                t13
            ]
        });
        $[27] = classes.quote;
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
        $[31] = t14;
    } else t14 = $[31];
    let t15;
    if ($[32] !== editor || $[33] !== handleSubmit || $[34] !== isQuoteDialogOpen || $[35] !== quoteAuthor || $[36] !== quoteText) {
        t15 = isQuoteDialogOpen && /*#__PURE__*/ jsx(QuoteDialog, {
            editor: editor,
            open: isQuoteDialogOpen,
            onClose: handleQuoteDialogClose,
            selectionText: quoteText,
            authorText: quoteAuthor,
            handleSubmit: handleSubmit,
            edit: true
        });
        $[32] = editor;
        $[33] = handleSubmit;
        $[34] = isQuoteDialogOpen;
        $[35] = quoteAuthor;
        $[36] = quoteText;
        $[37] = t15;
    } else t15 = $[37];
    let t16;
    if ($[38] !== t14 || $[39] !== t15) {
        t16 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t14,
                t15
            ]
        });
        $[38] = t14;
        $[39] = t15;
        $[40] = t16;
    } else t16 = $[40];
    return t16;
};
export { Quote };
